import { DocumentoArrecadacaoRetificacaoBase1TO } from "src/app/pagamento/models/documento-arrecadacao-retificacao-base1-to";

export const DOCUMENTO_ARRECADACAO_CNPJ_COMPLETA_MOCK: DocumentoArrecadacaoRetificacaoBase1TO = {
  numeroRegistro: "1036002065", 
  numeroDocumento: "10100107829000511", 
  ni: "12229753000152", 
  dataArrecadacao: "2024-01-22", 
  dataVencimento: "2024-01-22", 
  periodoApuracao: "2023-12-18", 
  referencia: "21180093200951900", 
  processo: null, 
  idCEF: null, 
  vrba: null, 
  vrbaPercentual: null, 
  codigoBanco: "001", 
  codigoAgencia: "0013", 
  codigoReceita01: "6092", 
  codigoReceita02: null, 
  codigoReceita03: null, 
  codigoExtensaoReceita01: null, 
  valorReceita01: 3568.67, 
  valorReceita02: null, 
  valorReceita03: null, 
  valorTotal: 3568.67, 
  tipoDocumento: { 
    codigo: 4, 
    descricao: "DARF" 
  }, 
  situacaoDocumento: { 
    codigo: 2, 
    descricao: "Alterado" 
  }, 
  tiicCd: null, 
  idVersao: "1748558931000", 
  isDocumentoNumerado: false, 
  isNiInvalido: false, 
  isCancelaDocAlocPaex: false, 
  isAlteraPABase2: null, 
  isAlteradoDocumentoAlocado: null, 
  processoAlteracao: null, 
  origemErro: "2", 
  desmembramentos: null
};
